import React, { useState } from 'react';

interface HelpTooltipProps {
  content: string;
  title?: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  className?: string;
}

export const HelpTooltip: React.FC<HelpTooltipProps> = ({ 
  content, 
  title,
  position = 'top',
  className = '' 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  
  const positionClasses = {
    top: 'bottom-full left-1/2 transform -translate-x-1/2 mb-2',
    bottom: 'top-full left-1/2 transform -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 transform -translate-y-1/2 mr-2',
    right: 'left-full top-1/2 transform -translate-y-1/2 ml-2'
  };
  
  const arrowClasses = {
    top: 'bottom-[-4px] left-1/2 transform -translate-x-1/2 rotate-45',
    bottom: 'top-[-4px] left-1/2 transform -translate-x-1/2 rotate-45',
    left: 'right-[-4px] top-1/2 transform -translate-y-1/2 rotate-45',
    right: 'left-[-4px] top-1/2 transform -translate-y-1/2 rotate-45'
  };
  
  return (
    <div className={`relative inline-block ${className}`}>
      <button
        type="button"
        onClick={() => setIsVisible(!isVisible)}
        className="text-gray-400 hover:text-gray-600 transition-colors p-1"
        aria-label="Aide"
      >
        <i className="fas fa-question-circle text-sm"></i>
      </button>
      
      {isVisible && (
        <>
          {/* Overlay pour fermer au clic */}
          <div 
            className="fixed inset-0 z-40"
            onClick={() => setIsVisible(false)}
          />
          
          {/* Tooltip */}
          <div 
            className={`
              absolute z-50 w-64 p-3 bg-gray-900 text-white rounded-lg shadow-xl
              ${positionClasses[position]}
            `}
          >
            {/* Flèche */}
            <div 
              className={`
                absolute w-2 h-2 bg-gray-900
                ${arrowClasses[position]}
              `}
            />
            
            {/* Contenu */}
            <div className="relative">
              {title && (
                <h4 className="font-semibold text-sm mb-1">{title}</h4>
              )}
              <p className="text-xs leading-relaxed">{content}</p>
              
              {/* Bouton fermer */}
              <button
                onClick={() => setIsVisible(false)}
                className="absolute -top-1 -right-1 text-gray-400 hover:text-white"
              >
                <i className="fas fa-times text-xs"></i>
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
